import { Storage } from '~/shared/utils/storage/storage';
import { useLocalStorageNumber } from '../utils';

export default function useWarehouseId() {
    return useLocalStorageNumber(Storage.warehouseId, undefined);
}
